__webpack_require__.p = "/ngp_erp/";